import React, { useRef, useState } from 'react';

import { useParams } from 'react-router-dom';

import { SafeCharge, tenantDetails } from '../../../helpers/utils/types';

import { PaymentProvider } from '../../../helpers/hooks/PaymentContext';

import { motion } from 'framer-motion';
import CardSection from '../CardSection/CardSection';
import OrderSummary from '../OrderSummary/OrderSummary';

import NoPaymentOptions from '../NoPaymentOptions/NoPaymentOptions';
import { useModal } from '../../../helpers/hooks/modalContext';
import { Spinner } from '../../../helpers/UI/Spinner/Spinner';
import { usePaymentOptions } from '../../../helpers/hooks/PaymentOptionsContext';

interface PaymentPageProps {
  safeCharge: SafeCharge;
  tenant?: tenantDetails;
}

const PaymentPage: React.FC<PaymentPageProps> = ({ safeCharge }) => {
  const { tenantBuildingId } = useParams();

  const { setModal } = useModal();
  const cardSectionRef = useRef<any>(null);
  const { paymentType } = useParams();
  const [isPaying, setIsPaying] = useState(false);
  const { paymentOptions, loading } = usePaymentOptions();

  const handleDirectPay = () => {
    cardSectionRef.current?.createDirectPayment();
  };

  const handleSubscriptionPay = () => {
    cardSectionRef.current?.requestAutopay?.();
  };
  if (loading) {
    return <Spinner />;
  }
  return (
    <PaymentProvider>
      <motion.section
        initial={{ opacity: 0, y: -5 }} // Starts slightly above
        animate={{ opacity: 1, y: 0 }} // Slides down to position
        transition={{ duration: 0.4, ease: 'easeOut' }}
      >
        {paymentOptions.length === 0 ? (
          <div className='flex flex-col items-center justify-center h-full p-48'>
            <NoPaymentOptions onAddPayment={() => setModal('add-payment-method')} />
          </div>
        ) : (
          <div className='flex flex-col xl2:flex-row gap-5 w-full'>
            {/* Left Column */}
            <div className='flex-[7] w-full p-12 flex flex-col gap-10 border-r border-[#DEE2EF]'>
              <div className='text-main text-xl '>Select payment method</div>
              <CardSection
                ref={cardSectionRef}
                tenantBuildingId={tenantBuildingId}
                paymentType={paymentType ?? ''}
                safeCharge={safeCharge}
                setIsPaying={setIsPaying}
              />
            </div>

            {/* Right Column */}
            <div className='flex-[3] p-12 '>
              <OrderSummary
                paymentType={paymentType ?? ''}
                tenantBuildingId={tenantBuildingId}
                onDirectPay={handleDirectPay}
                onSubscriptionPay={handleSubscriptionPay}
                isPaying={isPaying}
              />
            </div>
          </div>
        )}
      </motion.section>
    </PaymentProvider>
  );
};

export default PaymentPage;
